"use strict";
/*******************************************************************************

    Includes class to help package BOA Sodium

    This is designed to compensate for the slow loading of packages.

    Copyright:
        Copyright (c) 2020-2021 BOSAGORA Foundation
        All rights reserved.

    License:
        MIT License. See LICENSE for details.

*******************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.SodiumHelper = void 0;
/**
 * The Class to help package BOA Sodium
 */
var SodiumHelper = /** @class */ (function () {
    function SodiumHelper() {
    }
    /**
     * Assign BOA Sodium Module
     * @param sodium The interface of IBOASodium
     */
    SodiumHelper.assign = function (sodium) {
        SodiumHelper._sodium = sodium;
    };
    /**
     * Verify that the module is assigned.
     * @returns Returns true if the module is specified or false if not.
     */
    SodiumHelper.isAssigned = function () {
        return SodiumHelper._sodium !== undefined;
    };
    /**
     * Wait until the package is loaded.
     */
    SodiumHelper.init = function () {
        return SodiumHelper._sodium.init();
    };
    Object.defineProperty(SodiumHelper, "sodium", {
        /**
         * Returns the object of the package that has already been loaded.
         * If loading is not completed, throw an error.
         */
        get: function () {
            if (SodiumHelper._sodium === null)
                throw new Error("The package libsodium did not complete loading.");
            return SodiumHelper._sodium;
        },
        enumerable: false,
        configurable: true
    });
    return SodiumHelper;
}());
exports.SodiumHelper = SodiumHelper;
//# sourceMappingURL=SodiumHelper.js.map